import { useNavigate, NavLink, Outlet } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useEntitlements } from "../../hooks/useEntitlements";
import SubscriptionInactiveGate from "../../components/SubscriptionInactiveGate";
import "./MessagingLayout.css";

const TABS = [
  { to: "/messaging", end: true, label: "Send" },
  { to: "/messaging/campaigns", end: false, label: "Campaigns" },
  { to: "/messaging/templates", end: false, label: "Templates" },
  { to: "/messaging/logs", end: false, label: "Message Logs" },
  { to: "/messaging/rules", end: false, label: "Rules and Regulation" },
];

const MessagingLayout = () => {
  const navigate = useNavigate();
  const { entitlements, loading } = useEntitlements();

  const handleSectionChange = (key: string) => {
    if (key === "messaging") return;
    navigate(`/dashboard?section=${encodeURIComponent(key)}`);
  };

  const hasActive = entitlements?.hasActiveSubscription === true;

  const renderGate = () => {
    if (!hasActive) {
      return (
        <SubscriptionInactiveGate
          title="Subscription inactive"
          message="Your organization does not have an active subscription. Please contact the platform administrator."
        />
      );
    }
    return (
      <SubscriptionInactiveGate
        title="Messaging not included"
        message="Messaging is not included in your current plan. Please contact the platform administrator to upgrade."
      />
    );
  };

  return (
    <DashboardLayout
      activeSection="messaging"
      onSectionChange={handleSectionChange}
    >
      <div className="msg-layout">
        {loading ? (
          <div className="msg-layout__loading">Loading subscription…</div>
        ) : !hasActive || !entitlements?.messagingEnabled ? (
          renderGate()
        ) : (
          <>
            <nav className="msg-tabs" aria-label="Messaging sections">
              {TABS.map((tab) => (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  end={tab.end}
                  className={({ isActive }) =>
                    `msg-tabs__link ${isActive ? "msg-tabs__link--active" : ""}`
                  }
                >
                  {tab.label}
                </NavLink>
              ))}
            </nav>

            <div className="msg-layout__content">
              <Outlet />
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MessagingLayout;